import React, { useEffect, useState, Fragment } from 'react'
import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormControl } from 'react-bootstrap'

import { GlgPopupForm, GlgCheckbox } from 'SharedComponents'
import { getPotentialCloneCandidateData } from '../../../../selectors'

const PartsToCloneFromEventLeague = ({
  details,
  setDetails,
  getLeaguePotentialCloneCandidate,
  leaguePotentialCloneCandidate,
  copyOptionsFields,
  setCopyOptionsFields,
}) => {
  let isNonGolfEvent = false

  const computeCopyOptionsData = (fields) => [
    fields.copyManagers ? 'copy_managers' : '',
    fields.copyPlayerRoster ? 'copy_player_roster' : '',
    fields.copyLogos ? 'copy_logos' : '',
    fields.copyAllPortalPages ? 'copy_all_portal_pages' : '',
    fields.openRegistration ? 'open_registration' : '',
    fields.tournaments ? 'tournaments' : '',
    fields.tournamentLibrary ? 'tournament_library' : '',
    fields.golfHubPage ? 'golf_hub_page' : '',
    fields.copyDft ? 'copy_dft' : '',
    fields.roundsAndSeries ? 'rounds_and_series' : '',
    fields.stripeAccount ? 'stripe_account' : '',
    fields.registrationPaymentOptions ? 'registration_payment_options' : '',
  ]

  useEffect(() => {
    if (details.fromEventLeague) {
      getLeaguePotentialCloneCandidate(details.fromEventLeague)
    }
    setDetails({ ...details, copyOptions: computeCopyOptionsData(copyOptionsFields) })
  }, [])

  useEffect(() => {
    if (leaguePotentialCloneCandidate)
      setDetails({ ...details, ...leaguePotentialCloneCandidate, name: details.name, category: details.category, season: details.season, copyOptions: computeCopyOptionsData(copyOptionsFields) })
  }, [leaguePotentialCloneCandidate])

  useEffect(() => {
    if (details) {
      const needDftAndRounds = true || details.isExpressEvent
      setCopyOptionsFields({
        ...copyOptionsFields,
        copyManagers: copyOptionsFields?.copyManagers ?? (details.managers?.length > 0),
        openRegistration: copyOptionsFields?.openRegistration ?? (details.openRegistrationData?.hasOpenRegistration || details.copyStripeAndFees),
        openRegistrationDisabled: copyOptionsFields?.openRegistrationDisabled ?? details.copyStripeAndFees,
        stripeAccount: copyOptionsFields?.stripeAccount ?? details.stripeAccount,
        registrationPaymentOptions: copyOptionsFields?.registrationPaymentOptions ?? details.copyStripeAndFees,
        copyDft: copyOptionsFields?.copyDft ?? needDftAndRounds,
        copyDftDisabled: copyOptionsFields?.copyDftDisabled ?? needDftAndRounds,
        roundsAndSeries: copyOptionsFields?.roundsAndSeries ?? needDftAndRounds,
        roundsAndSeriesDisabled: copyOptionsFields?.roundsAndSeriesDisabled ?? needDftAndRounds,
        golfHubPage: copyOptionsFields?.golfHubPage ?? details.golfHub !== '',
        copyPlayerRoster: copyOptionsFields?.copyPlayerRoster ?? false,
        copyLogos: copyOptionsFields?.copyLogos ?? true,
        copyAllPortalPages: copyOptionsFields?.copyAllPortalPages ?? true,
        tournaments: copyOptionsFields?.tournaments ?? true,
        tournamentLibrary: copyOptionsFields?.tournamentLibrary ?? true,
      })
    }
  }, [details])

  const handleChange = (key, value) => {
    let newFields
    if (key === 'tournaments') {
      if (value) {
        newFields = {
          ...copyOptionsFields,
          tournaments: true,
          copyDft: true,
          copyDftDisabled: true,
          roundsAndSeries: true,
          roundsAndSeriesDisabled: true,
        }
      } else {
        newFields = {
          ...copyOptionsFields,
          tournaments: false,
          copyDft: false,
          copyDftDisabled: false,
          roundsAndSeriesDisabled: false,
        }
      }
    } else if (key === 'registrationPaymentOptions') {
      if (value) {
        newFields = {
          ...copyOptionsFields,
          openRegistration: true,
          openRegistrationDisabled: true,
        }
      } else {
        newFields = {
          ...copyOptionsFields,
          openRegistrationDisabled: false,
        }
      }
    } else {
      newFields = {
        ...copyOptionsFields,
        [key]: !copyOptionsFields[key],
      }
    }

    setCopyOptionsFields(newFields)
    setDetails({ ...details, copyOptions: computeCopyOptionsData(newFields) })
  }

  const getManagersTooltip = () => {
    return details.managers && details.managers.map(manager => (
      `${ manager.name } (${ manager.email })`
    )).join('\n')
  }

  return (
    <span className='popup_form_content parts_to_clone'>
      <h2 className='clone_options'>{ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.parts_to_clone_header') }</h2>
      <GlgPopupForm>
        {details.fromEventLeague && (
          <Fragment>
            <FormControl type='hidden' name='league_id' value={ details.fromEventLeague } />
            {/* <FormControl type='hidden' name='product' value={ props.data.fromProduct } /> */}
            <FormControl type='hidden' name='name' value={ details.name } />
            <FormControl type='hidden' name='category' value={ details.category } />
            <FormControl type='hidden' name='season' value={ details.season } />
            <FormControl type='hidden' name='tour' value={ details.tour } />
            <FormControl type='hidden' name='is_express_event' value={ details.isExpressEvent } />
            <FormControl type='hidden' name='payment_model' value={ details.paymentModel } />
            <FormControl type='hidden' name='mass_dates' value={ details.rounds && details.rounds.map(day => moment(day).format('MM/DD/YYYY')) }  />
          </Fragment>
        )}
        { details.managers && details.managers.length > 0 && (
          <GlgCheckbox
            name='copy_options[]'
            value='copy_managers'
            label='Managers'
            checked={ copyOptionsFields?.copyManagers ?? true }
            onChange={ (val) => {
              handleChange('copyManagers', val)
            }}
            tooltip={ getManagersTooltip() }
          />
        )}
        <GlgCheckbox
          name='copy_options[]'
          value='copy_player_roster'
          label={ isNonGolfEvent ? 'Participants' : 'Player Roster' }
          checked={ copyOptionsFields?.copyPlayerRoster ?? false }
          onChange={ (val) => {
            handleChange('copyPlayerRoster', val)
          }}
        />
        <GlgCheckbox
          name='copy_options[]'
          value='copy_logos'
          label='Logos and Banners'
          checked={ copyOptionsFields?.copyLogos ?? true }
          onChange={ (val) => {
            handleChange('copyLogos', val)
          }}
          tooltip='If unchecked, we will copy the logos and banners from the default website logos and banners (Customer Settings > Logos, Banners & Backgrounds).'
        />
        <GlgCheckbox
          name='copy_options[]'
          value='copy_all_portal_pages'
          label='Member Portal'
          checked={ copyOptionsFields?.copyAllPortalPages ?? true }
          onChange={ (val) => {
            handleChange('copyAllPortalPages', val)
          }}
          tooltip='If unchecked, we will copy from the default member portal (Customer Settings > Default League / Event Member Portal)'
        />
        { (details.openRegistrationData && details.openRegistrationData.hasOpenRegistration) || details.copyStripeAndFees && (
          <GlgCheckbox
            name='copy_options[]'
            value='open_registration'
            label='Registration Form'
            checked={ copyOptionsFields?.openRegistration ?? true }
            disabled={ copyOptionsFields?.openRegistrationDisabled ?? true }
            onChange={ (val) => {
              handleChange('openRegistration', val)
            }}
          />
        )}
        { !isNonGolfEvent && (
          <GlgCheckbox
            name='copy_options[]'
            value='tournaments'
            label='Tournaments'
            checked={ copyOptionsFields?.tournaments ?? true }
            onChange={ (val) => {
              handleChange('tournaments', val)
            }}
            tooltip="Cloning Tournaments requires cloning Event Divisions / Flights / Teams' and 'Rounds & Series'"
          />
        )}
        { !isNonGolfEvent && (
          <GlgCheckbox
            name='copy_options[]'
            value='tournament_library'
            label='Tournament Library'
            checked={ copyOptionsFields?.tournamentLibrary ?? true }
            onChange={ (val) => {
              handleChange('tournamentLibrary', val)
            }}
          />
        )}
        { details.golfHub !== '' && (
          <GlgCheckbox
            name='copy_options[]'
            value='golf_hub_page'
            label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.clone_event_copy_options_popup.gh_page' )}
            checked={ copyOptionsFields?.golfHubPage ?? true }
            onChange={ (val) => {
              handleChange('golfHubPage', val)
            }}
          />
        )}
        <GlgCheckbox
          name='copy_options[]'
          value='copy_dft'
          label={ isNonGolfEvent ? 'Event Divisions / Teams' : 'Event Divisions / Flights / Teams' }
          checked={ copyOptionsFields?.copyDft ?? true }
          disabled={ copyOptionsFields?.copyDftDisabled ?? true }
          onChange={ (val) => {
            handleChange('copyDft', val)
          }}
        />
        <GlgCheckbox
          name='copy_options[]'
          value='rounds_and_series'
          label={
          isNonGolfEvent ? (
            <>Dates & Series</>
          ) : (
            <>Rounds & Series</>
          )
          }
          checked={ copyOptionsFields?.roundsAndSeries ?? true }
          disabled={ copyOptionsFields?.roundsAndSeriesDisabled ?? true }
          onChange={ (val) => {
            handleChange('roundsAndSeries', val)
          }}
        />
        { details.stripeAccount && (
          <GlgCheckbox
            name='copy_options[]'
            value='stripe_account'
            label='Payment Gateway'
            checked={ copyOptionsFields?.stripeAccount ?? true }
            onChange={ (val) => {
              handleChange('stripeAccount', val)
            }}
          />
        )}
        { details.copyStripeAndFees && (
          <GlgCheckbox
            name='copy_options[]'
            value='registration_payment_options'
            label='Registration Payment Options'
            checked={ copyOptionsFields?.registrationPaymentOptions ?? true }
            onChange={ (val) => {
              handleChange('registrationPaymentOptions', val)
            }}
          />
        )}
      </GlgPopupForm>
    </span>
  )
}

PartsToCloneFromEventLeague.propTypes = {
  details: PropTypes.object.isRequired,
  setDetails: PropTypes.func.isRequired,
  getLeaguePotentialCloneCandidate: PropTypes.func.isRequired,
  leaguePotentialCloneCandidate: PropTypes.object.isRequired,
  copyOptionsFields: PropTypes.object.isRequired,
  setCopyOptionsFields: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  const leaguePotentialCloneCandidate = getPotentialCloneCandidateData(state)

  return {
    leaguePotentialCloneCandidate,
  }
}

export default connect(mapStateToProps)(PartsToCloneFromEventLeague)

